import { useLang } from "hooks/useLang";
import React, { useState } from "react";

type QuestionOption = {
  label: { en: string; ar: string };
  option_id: string;
  _id: string;
};

type Question = {
  label: { en: string; ar: string };
  question_id: string;
  type: "text" | "email" | "phone_number" | "radio" | "multiselect";
  is_required: boolean;
  options?: QuestionOption[];
  _id: string;
};

type Answer = {
  question_id: string;
  answer: string;
};

interface Props {
  questions: Question[];
  answers: Answer[];
  onChange: (
    questionId: string,
    value: string,
    type?: string,
    isRequired?: boolean
  ) => void;
  errors?: Record<string, string>;
}

const AccreditationForm: React.FC<Props> = ({
  questions,
  answers,
  onChange,
  errors = {},
}) => {
  const { t, multiLangVars, lang } = useLang();

  const getValue = (questionId: string) => {
    return answers.find((a) => a.question_id === questionId)?.answer || "";
  };

  const getRoundedStyle = (isFirst, isLast) => {
    return isFirst && isLast
      ? "rounded-2xl"
      : isFirst
      ? "rounded-t-2xl"
      : isLast
      ? "rounded-b-2xl"
      : "";
  };
 

  return (
    <div className="add-ons-container flex flex-col gap-y-1">
      {" "}
      {/**gap-y-6 */}
      {questions.map((q, index) => (
        <div
          key={q._id}
          className={`flex flex-col gap-2 p-4 ${getRoundedStyle(
            index === 0,
            index === questions.length - 1
          )} bg-[#fff]`}
        >
          {/* Label */}
          <label className="font-medium text-[#201750]">
            {" "}
            {/**text-white */}
            {q.label[lang]}{" "}
            {q.is_required && <span className="text-red-500 ml-1">*</span>}
          </label>

          {/* Input Types */}
          {q.type === "text" && (
            <input
              type="text"
              //value={answers[q.question_id] || ""}
              value={getValue(q.question_id)}
              onChange={(e) =>
                onChange(q.question_id, e.target.value, q.type, q.is_required)
              }
              required={q.is_required}
              className={`border rounded-lg p-2 focus:outline-none focus:ring-2 text-[#201750] bg-[#FFFFFF4D]
                ${
                  errors[q.question_id]
                    ? "border-red-500"
                    : "focus:ring-mint-green-500"
                }`}
            />
          )}

          {q.type === "email" && (
            <input
              type="email"
              //value={answers[q.question_id] || ""}
              value={getValue(q.question_id)}
              onChange={(e) =>
                onChange(q.question_id, e.target.value, q.type, q.is_required)
              }
              required={q.is_required}
              className={`border rounded-lg p-2 focus:outline-none focus:ring-2 text-[#201750] bg-[#FFFFFF4D] 
                ${
                  errors[q.question_id]
                    ? "border-red-500"
                    : "focus:ring-mint-green-500"
                }`}
            />
          )}

          {q.type === "phone_number" && (
            <input
              type="text"
              //value={answers[q.question_id] || ""}
              value={getValue(q.question_id)}
              onChange={(e) =>
                onChange(q.question_id, e.target.value, q.type, q.is_required)
              }
              required={q.is_required}
              className={`border rounded-lg p-2 focus:outline-none focus:ring-2 text-[#201750] bg-[#FFFFFF4D] 
                ${
                  errors[q.question_id]
                    ? "border-red-500"
                    : "focus:ring-mint-green-500"
                }`}
              placeholder="9665XXXXXXXX"
            />
          )}

          {q.type === "radio" && (
            <div className="space-y-2">
              {q.options?.map((opt) => (
                <label
                  key={opt._id}
                  className="flex items-center gap-2 cursor-pointer text-[#201750]"
                >
                  <input
                    type="radio"
                    name={q.question_id}
                    value={opt.option_id}
                    className="form-radio accent-mint-green-500"
                    checked={getValue(q.question_id) === opt.option_id}
                    onChange={() =>
                      onChange(
                        q.question_id,
                        opt.option_id,
                        q.type,
                        q.is_required
                      )
                    }
                    required={q.is_required}
                  />
                  <span>{opt.label[lang]}</span>
                </label>
              ))}
            </div>
          )}
          {/* Error Message */}
          {errors[q.question_id] && (
            <span className="text-red-500 text-sm">
              {errors[q.question_id]}
            </span>
          )}
        </div>
      ))}
    </div>
  );
};

export default AccreditationForm;
